<template>
  <svg viewBox="0 0 64 64">
    <path
      d="M62.4,55.4c-2.7,0-3.9-1-5.4-2.1c-1.6-1.2-3.4-2.6-6.8-2.6c-3.5,0-5.3,1.4-6.8,2.6c-1.5,1.1-2.7,2.1-5.4,2.1
                    c-2.7,0-3.9-1-5.4-2.1c-1.6-1.2-3.4-2.6-6.8-2.6c-3.5,0-5.2,1.4-6.8,2.6c-1.5,1.1-2.7,2.1-5.4,2.1c-2.7,0-3.9-1-5.4-2.1
                    c-1.6-1.2-3.4-2.6-6.8-2.6c-0.6,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c2.7,0,3.9,1,5.4,2.1c1.6,1.2,3.4,2.6,6.8,2.6
                    c3.5,0,5.2-1.4,6.8-2.6c1.5-1.1,2.7-2.1,5.4-2.1c2.7,0,3.9,1,5.4,2.1c1.6,1.2,3.4,2.6,6.8,2.6c3.5,0,5.3-1.4,6.8-2.6
                    c1.5-1.1,2.7-2.1,5.4-2.1c2.7,0,3.9,1,5.4,2.1c1.6,1.2,3.4,2.6,6.8,2.6c0.7,0,1.2-0.5,1.2-1.2C63.6,55.9,63,55.4,62.4,55.4z"
    />
    <path
      d="M62.4,46.8c-2.7,0-3.9-1-5.4-2.1c-1.6-1.2-3.4-2.6-6.8-2.6c-3.5,0-5.3,1.4-6.8,2.6c-1.5,1.1-2.7,2.1-5.4,2.1
                    c-2.7,0-3.9-1-5.4-2.1c-1.6-1.2-3.4-2.6-6.8-2.6c-3.5,0-5.3,1.4-6.8,2.6c-1.5,1.1-2.7,2.1-5.4,2.1c-2.7,0-3.9-1-5.4-2.1
                    c-1.6-1.2-3.4-2.6-6.8-2.6c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c2.7,0,3.9,1,5.4,2.1c1.6,1.2,3.4,2.6,6.8,2.6
                    c3.5,0,5.3-1.4,6.8-2.6c1.5-1.1,2.7-2.1,5.4-2.1c2.7,0,3.9,1,5.4,2.1c1.6,1.2,3.4,2.6,6.8,2.6c3.5,0,5.3-1.4,6.8-2.6
                    c1.5-1.1,2.7-2.1,5.4-2.1c2.7,0,3.9,1,5.4,2.1c1.6,1.2,3.4,2.6,6.8,2.6c0.6,0,1.2-0.5,1.2-1.2C63.6,47.3,63,46.8,62.4,46.8z"
    />
    <path
      d="M1.2,35.1c2.7,0,3.9,1,5.4,2.1c1.6,1.2,3.4,2.6,6.8,2.6c3.5,0,5.2-1.4,6.8-2.6c1.5-1.1,2.7-2.1,5.4-2.1
                    c2.7,0,3.9,1,5.4,2.1c1.6,1.2,3.4,2.6,6.8,2.6c3.5,0,5.3-1.4,6.8-2.6c1.5-1.1,2.7-2.1,5.4-2.1c2.7,0,3.9,1,5.4,2.1
                    c1.6,1.2,3.4,2.6,6.8,2.6c0.7,0,1.2-0.5,1.2-1.2c0-0.7-0.5-1.2-1.2-1.2c-2.7,0-3.9-1-5.4-2.1c-1.6-1.2-3.4-2.6-6.8-2.6
                    c-3.5,0-5.3,1.4-6.8,2.6c-1.5,1.1-2.7,2.1-5.4,2.1c-2.7,0-3.9-1-5.4-2.1c-1.6-1.2-3.4-2.6-6.8-2.6c-3.5,0-5.2,1.4-6.8,2.6
                    c-1.5,1.1-2.7,2.1-5.4,2.1c-2.7,0-3.9-1-5.4-2.1c-1.6-1.2-3.4-2.6-6.8-2.6c-0.6,0-1.2,0.5-1.2,1.2C0,34.6,0.5,35.1,1.2,35.1z"
    />
    <path
      d="M13.1,30.5h0.1c5.1-0.1,9.2-4.3,9.1-9.4c-0.1-4.8-7.7-12.8-8.6-13.7C13.6,7.1,13.3,7,13,7c-0.3,0-0.6,0.1-0.9,0.4
                    c-0.9,0.9-8.4,9.2-8.3,14C3.9,26.4,8.1,30.5,13.1,30.5z M13,9.9c2.5,2.8,7,8.3,7,11.2c0.1,3.8-3,7-6.8,7l-0.1,1.2v-1.2
                    c-3.8,0-6.9-3.1-6.9-6.8C6.1,18.4,10.5,12.8,13,9.9z"
    />
    <path
      d="M9.4,22.4L9.4,22.4l2.6,0l0,2.6c0,0.6,0.5,1.2,1.2,1.2h0c0.6,0,1.2-0.5,1.2-1.2l0-2.6l2.6,0c0.7,0,1.2-0.5,1.2-1.2
                    c0-0.6-0.5-1.2-1.2-1.2h0l-2.6,0l0-2.5c0-0.6-0.5-1.1-1.2-1.2c-0.7,0-1.2,0.5-1.2,1.2l0,2.6l-2.6,0c-0.7,0-1.2,0.5-1.2,1.2
                    C8.2,21.9,8.7,22.4,9.4,22.4z"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconSWW extends Vue {}
</script>
